import EditableMuiDatePicker from "Global/Components/EditableComponents/EditableMuiDatePicker/EditableMuiDatePicker";
import MuiDatePicker from "Global/Components/UnEditableComponents/MuiDatePicker/MuiDatePicker";
import React from "react";

const DatePickerEditTernary = ({ field, element, onChange }) => {
  return (
    <React.Fragment>
      {field?.UiValue?.Value.length > 0 ? (
        <EditableMuiDatePicker
          Placeholder={element?.LablelNameForWeb}
          onChange={onChange}
          disableInit={true}
          initialValue={field?.UiValue?.Value}
        />
      ) : (
        <MuiDatePicker
          Placeholder={element?.LablelNameForWeb}
          onChange={onChange}
          disableInit={true}
        />
      )}
    </React.Fragment>
  );
};

export default DatePickerEditTernary;
